import { IonDatetime, IonLabel, IonText } from '@ionic/react';
import {
  ControlProps,
  ControlState,
  computeLabel,
  isDateControl,
  rankWith,
} from '@jsonforms/core';
import { Control, withJsonFormsControlProps } from '@jsonforms/react';
import { merge } from 'lodash';
import { IonItem } from '../../ionic/IonItem';

class IonicDatePickerControlInner extends Control<ControlProps, ControlState> {
  private hasFocused = false;
  render() {
    const {
      data,
      description,
      enabled,
      errors,
      label,
      uischema,
      visible,
      required,
      config,
      handleChange,
      path,
    } = this.props;

    const appliedUiSchemaOptions = merge({}, config, uischema.options);

    const errorText = this.hasFocused ? (
      <IonText color="danger">{errors}</IonText>
    ) : null;

    const className = visible === false ? 'ion-hide' : '';

    const computedLabel = computeLabel(
      typeof label === 'string' ? label : '',
      required ?? false,
      appliedUiSchemaOptions.hideRequiredAsterisk
    );

    return (
      <IonItem lines={'full'} className={className}>
        <IonLabel position="floating" color="primary">
          {computedLabel} {errorText}
        </IonLabel>
        <IonDatetime
          placeholder={description}
          disabled={!enabled}
          value={data}
          onIonChange={(e) => {
            if (e.detail.value !== undefined) {
              handleChange(path, e.detail.value);
            }
          }}
        />
      </IonItem>
    );
  }
}

const IonicDatePickerTester = rankWith(10, isDateControl);
const IonicDatePickerControl = withJsonFormsControlProps(
  IonicDatePickerControlInner
);
export { IonicDatePickerControl, IonicDatePickerTester };
